<div class="font-7 d-flex text-white position-relative">
    <div class="popup-title p-4 d-inline-block primary-bg-300">{{label()}}</div>
    <div class=" flex-grow-1 position-relative primary-bg-300">
        <div class="position-absolute font-5 w-100 text-red-500 popup-curve px-4 w-75 pb-0 end-0 text-end primary-bg-150 bottom-0 pt-3">
            @if(hasMandatoryFields())
            {
                <span class="font-3">Mandatory Fields*</span>
            }
            @else {
                <span>&nbsp;</span>
            }
        </div>
    </div>
</div>